/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
} from './Direction';
import type { LookupMappings } from './LookupMappings';
import {
    LookupMappingsFromJSON,
    LookupMappingsFromJSONTyped,
    LookupMappingsToJSON,
} from './LookupMappings';
import type { PromptGroups } from './PromptGroups';
import {
    PromptGroupsFromJSON,
    PromptGroupsFromJSONTyped,
    PromptGroupsToJSON,
} from './PromptGroups';

/**
 * 
 * @export
 * @interface CreatePromptRevisionRequestContent
 */
export interface CreatePromptRevisionRequestContent {
    /**
     * Fixed Prompt Hash Key
     * @type {string}
     * @memberof CreatePromptRevisionRequestContent
     */
    promptHashKey: string;
    /**
     * Name of the prompt revision
     * @type {string}
     * @memberof CreatePromptRevisionRequestContent
     */
    name: string;
    /**
     * 
     * @type {PromptGroups}
     * @memberof CreatePromptRevisionRequestContent
     */
    promptGroups: PromptGroups;
    /**
     * 
     * @type {LookupMappings}
     * @memberof CreatePromptRevisionRequestContent
     */
    queueIds?: LookupMappings;
    /**
     * 
     * @type {Direction}
     * @memberof CreatePromptRevisionRequestContent
     */
    initialDirection?: Direction;
    /**
     * 
     * @type {number}
     * @memberof CreatePromptRevisionRequestContent
     */
    duration?: number;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof CreatePromptRevisionRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the CreatePromptRevisionRequestContent interface.
 */
export function instanceOfCreatePromptRevisionRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "promptHashKey" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "promptGroups" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function CreatePromptRevisionRequestContentFromJSON(json: any): CreatePromptRevisionRequestContent {
    return CreatePromptRevisionRequestContentFromJSONTyped(json, false);
}

export function CreatePromptRevisionRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromptRevisionRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promptHashKey': json['promptHashKey'],
        'name': json['name'],
        'promptGroups': PromptGroupsFromJSON(json['promptGroups']),
        'queueIds': !exists(json, 'queueIds') ? undefined : LookupMappingsFromJSON(json['queueIds']),
        'initialDirection': !exists(json, 'initialDirection') ? undefined : DirectionFromJSON(json['initialDirection']),
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function CreatePromptRevisionRequestContentToJSON(value?: CreatePromptRevisionRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promptHashKey': value.promptHashKey,
        'name': value.name,
        'promptGroups': PromptGroupsToJSON(value.promptGroups),
        'queueIds': LookupMappingsToJSON(value.queueIds),
        'initialDirection': DirectionToJSON(value.initialDirection),
        'duration': value.duration,
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

